<template>
	<AgItem :rowData="offers"
			:columnDefs="columnDefs"
			min-height="164px"
			height-type="matchRows"
	/>
</template>

<script>
import AgItem from "@/components/templates/agGrid/AgItem";
import {asDecimal, asMoneyAmount} from "@/components/templates/agGrid/formatter/valueFormatters";

export default {
	props: {
		canAccept: { type: Boolean },
		offers: { type: Array, default: [] },
	},
	components: {
		AgItem,
	},
	data() {
		return {
			columnDefs: [],
		};
	},
	beforeMount() {
		this.setColumnDefs();
	},
	methods: {
		setColumnDefs() {
			this.columnDefs = [
				{
					headerName: this.$t("common.investor"),
					field: "ownerCompanyName",
					nameType: "ownerCompanyName",
					idType: "ownerCompanyId",
					cellRendererFramework: "CompanyTem",
				},
				{
					headerName: this.$t("revolvingPutOption.premium"),
					headerClass: "align-right",
					field: "premium",
					cellStyle: {'justify-content': 'flex-end'},
					valueFormatter: asDecimal({ showPercentSign: true }),
				},
				{
					headerName: this.$t("common.actions"),
					minWidth: 120,
					maxWidth: 120,
					cellRendererFramework: "RevolvingPutOptionOffersTableOperation",
					cellRendererParams: {
						canAccept: this.canAccept,
						accept: this.acceptOffer
					}
				},
			]
		},
		acceptOffer(data) {
			this.$emit("accept", data);
		}
	},
};
</script>